import React, { Component } from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"

import team1 from "../assets/img/main/proje-baslat1.png"
import svgnew from "../assets/img/main/aidanismanlik.svg"

class Convert extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errors: {},
      formStatus: "idle",
      statusMessage: "",
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
    this.handleFocus = this.handleFocus.bind(this)
  }

  requiredFieldIds = ["sirket", "ad", "eposta", "telefon"]

  validateField(id, fieldValue) {
    const isEmpty = !fieldValue || !fieldValue.trim()
    this.setState(prev => ({
      errors: { ...prev.errors, [id]: isEmpty ? "This field is required" : "" },
    }))
    return !isEmpty
  }

  handleBlur(e) {
    if (this.requiredFieldIds.includes(e.target.id)) {
      this.validateField(e.target.id, e.target.value)
    }
  }

  handleFocus(e) {
    if (!e.target || !e.target.id) return
    const id = e.target.id
    if (this.state.errors[id]) {
      this.setState(prev => ({
        errors: { ...prev.errors, [id]: "" },
      }))
    }
  }

  handleSubmit(e) {
    e.preventDefault()
    let isValid = true
    this.requiredFieldIds.forEach(id => {
      const field = document.querySelector(`#${id}`)
      if (!this.validateField(id, field ? field.value : "")) {
        isValid = false
      }
    })
    if (!isValid) return

    this.setState({ formStatus: "submitting" })

    const response = fetch(
      "https://forms.flatart.com.tr/index.php?r=app%2Ff&id=56",
      {
        method: "POST",
        body: JSON.stringify({
          text_942803: document.querySelector("#sirket").value,
          text_214911: document.querySelector("#ad").value,
          email_770619: document.querySelector("#eposta").value,
          text_708164: document.querySelector("#telefon").value,
          text_617097: document.querySelector("#hizmet").value || "-",
          text_795616: document.querySelector("#mesaj").value || "-",
        }),
        headers: { "Content-type": "application/json; charset=UTF-8" },
      }
    )
    response
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          this.setState({
            statusMessage: "Your message has been sent successfully.",
            formStatus: "success",
          })
          setTimeout(() => {
            if (typeof window !== "undefined") window.location.reload()
          }, 10000)
        } else {
          const msg =
            data.message &&
            (data.message.includes("This form is no longer accepting") ||
              data.message.includes("Limit"))
              ? "You have an active form submission, please try again later."
              : "An error occurred."
          this.setState({ statusMessage: msg, formStatus: "error" })
          setTimeout(() => {
            if (typeof window !== "undefined") window.location.reload()
          }, 10000)
        }
      })
      .catch(() => {
        this.setState({
          statusMessage: "An error occurred.",
          formStatus: "error",
        })
      })
  }

  render() {
    const { errors, formStatus, statusMessage } = this.state
    return (
      <Layout>
        <SEO
          title="Start Project | Flatart"
          description="Start a digital project to identify the areas need to be improved for your brand to grow!"
        />
        <div className="convert pb-hero-wrap" style={{ backgroundColor: "#efedea", padding: 0 }}>
          <div className="convert-hero container">
            <div className="col-md-4 noPadding">
              <div className="top">
                <h1 className="pb-baslik">Start Your Digital Project!</h1>
                <span className="pb-paragraf">
                  Data is the priority! Please fill out<br />
                  the form below so that we can get<br />
                  to know you a little better.
                </span>
              </div>
            </div>
            <div className="col-md-8 convert-image">
              <img alt="Start your digital project" src={team1} />
            </div>
          </div>
        </div>

        <div className="convert-service container uptade pb-narrow">
          <h2 style={{ color: "#ea4f6a", fontSize: 50, fontWeight: 600 }}>
            Start your digital project in 30 seconds
          </h2>
          <p style={{ fontSize: 25, fontWeight: 400, marginTop: 2 }}>
            Which digital marketing channels can we help you with?
          </p>
        </div>

        <div className="referances-detail container pb-narrow" style={{ marginTop: -30, marginBottom: 60 }}>
          <div className="col-md-12">
            <div className="provided">

              {formStatus === "success" || formStatus === "error" ? (
                <div className={`form-result ${formStatus}`}>
                  <p>{statusMessage}</p>
                </div>
              ) : (
                <form className="proje-form" onSubmit={this.handleSubmit} noValidate>
                  <div className="form-row">
                    <div className="form-group">
                      <input
                        type="text"
                        name="text_942803"
                        id="sirket"
                        placeholder=" "
                        className={errors.sirket ? "input-error" : ""}
                        required
                        onBlur={this.handleBlur}
                        onFocus={this.handleFocus}
                      />
                      <label htmlFor="sirket">Your Website *</label>
                      {errors.sirket && (
                        <span className="field-error">{errors.sirket}</span>
                      )}
                    </div>
                    <div className="form-group">
                      <input
                        type="text"
                        name="text_214911"
                        id="ad"
                        placeholder=" "
                        className={errors.ad ? "input-error" : ""}
                        required
                        onBlur={this.handleBlur}
                        onFocus={this.handleFocus}
                      />
                      <label htmlFor="ad">Name / Surname *</label>
                      {errors.ad && (
                        <span className="field-error">{errors.ad}</span>
                      )}
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <input
                        type="email"
                        name="email_770619"
                        id="eposta"
                        placeholder=" "
                        className={errors.eposta ? "input-error" : ""}
                        required
                        onBlur={this.handleBlur}
                        onFocus={this.handleFocus}
                      />
                      <label htmlFor="eposta">Work Email Address *</label>
                      {errors.eposta && (
                        <span className="field-error">{errors.eposta}</span>
                      )}
                    </div>
                    <div className="form-group">
                      <input
                        type="tel"
                        name="text_708164"
                        id="telefon"
                        placeholder=" "
                        className={errors.telefon ? "input-error" : ""}
                        required
                        onBlur={this.handleBlur}
                        onFocus={this.handleFocus}
                      />
                      <label htmlFor="telefon">Phone Number *</label>
                      {errors.telefon && (
                        <span className="field-error">{errors.telefon}</span>
                      )}
                    </div>
                  </div>

                  <div className="form-group">
                    <input
                      type="text"
                      name="text_617097"
                      id="hizmet"
                      placeholder=" "
                    />
                    <label htmlFor="hizmet">Service You Want (SEO, Digital Ads...)</label>
                  </div>

                  <div className="form-group">
                    <textarea
                      id="mesaj"
                      name="text_795616"
                      placeholder=" "
                    ></textarea>
                    <label htmlFor="mesaj">Main Goal of the Project</label>
                  </div>

                  <button
                    className="red-button baslat"
                    type="submit"
                    id="button_22942"
                    name="button_22942"
                    disabled={formStatus === "submitting"}
                  >
                    {formStatus === "submitting" ? (
                      <>
                        <span className="btn-spinner"></span>
                        Sending...
                      </>
                    ) : (
                      "SEND"
                    )}
                  </button>
                </form>
              )}

              <div className="hizmetler-section">
                <h2>Services</h2>
                <div className="hizmetler-grid">
                  <div className="hizmetler-card">
                    <a href="/search-engine-optimization/" target="_blank" rel="noreferrer"></a>
                    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 100 100">
                      <g transform="translate(0 0.249)">
                        <rect width="100" height="100" transform="translate(0 -0.249)" fill="none" />
                        <path d="M11.261,69.088H73.219a4.131,4.131,0,0,1,0,8.261H7.131A4.131,4.131,0,0,1,3,73.219V7.131a4.131,4.131,0,1,1,8.261,0Z" transform="translate(9.392 9.392)" fill="#111111" />
                        <path d="M14.144,40.3a4.131,4.131,0,0,1-6.027-5.65L23.607,18.132a4.131,4.131,0,0,1,5.695-.317L41.526,28.247,57.455,8.071a4.131,4.131,0,1,1,6.484,5.119L45.351,36.734a4.131,4.131,0,0,1-5.923.583L26.937,26.658Z" transform="translate(21.914 20.348)" fill="#111111" opacity="0.3" />
                      </g>
                    </svg>
                    <p>SEO</p>
                  </div>
                  <div className="hizmetler-card">
                    <a href="/social-media/" target="_blank" rel="noreferrer"></a>
                    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 76.462 76.462">
                      <path d="M55.361,0H21.1A21.125,21.125,0,0,0,0,21.1V55.362a21.124,21.124,0,0,0,21.1,21.1H55.361a21.125,21.125,0,0,0,21.1-21.1V21.1A21.125,21.125,0,0,0,55.361,0ZM69.679,55.362A14.333,14.333,0,0,1,55.362,69.678H21.1A14.332,14.332,0,0,1,6.784,55.362V21.1A14.333,14.333,0,0,1,21.1,6.784H55.361A14.333,14.333,0,0,1,69.678,21.1V55.362Z" />
                      <path d="M60.67,40.97a19.7,19.7,0,1,0,19.7,19.7A19.725,19.725,0,0,0,60.67,40.97Zm0,32.619A12.918,12.918,0,1,1,73.589,60.672,12.933,12.933,0,0,1,60.67,73.589Z" transform="translate(-22.439 -22.44)" />
                      <path d="M123.9,28.251a4.972,4.972,0,1,0,3.519,1.456A4.995,4.995,0,0,0,123.9,28.251Z" transform="translate(-65.136 -15.474)" />
                    </svg>
                    <p>Social Media</p>
                  </div>
                  <div className="hizmetler-card">
                    <a href="/digital-ads/" target="_blank" rel="noreferrer"></a>
                    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 95 95">
                      <rect width="95" height="95" fill="none" />
                      <path d="M65.116,38.389,62.355,54.954l-.01.057a3.958,3.958,0,0,1-4.6,3.186l-45-8.182a3.958,3.958,0,0,1-3.1-2.807L2.419,21.928a3.958,3.958,0,0,1,3.806-5.046H60.557l2.427-10.4a4.671,4.671,0,0,1,4.548-3.609h8.173a4.671,4.671,0,1,1,0,9.341H71.239Z" transform="translate(6.707 8.493)" fillRule="evenodd" opacity="0.3" />
                      <path d="M10.937,29.875a5.938,5.938,0,1,1,5.938-5.937A5.938,5.938,0,0,1,10.937,29.875Zm35.625,0A5.938,5.938,0,1,1,52.5,23.938,5.938,5.938,0,0,1,46.562,29.875Z" transform="translate(14.792 53.25)" fillRule="evenodd" />
                    </svg>
                    <p>Digital Ads</p>
                  </div>
                  <div className="hizmetler-card">
                    <a href="/digital-consulting/" target="_blank" rel="noreferrer"></a>
                    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 64 60">
                      <path fill="#000000" d="M21.224 29.867c-.156.125-.345.221-.567.289-.222.068-.478.104-.769.104-.344 0-.65-.035-.92-.107-.27-.07-.505-.148-.705-.23-.201-.082-.366-.158-.496-.229-.129-.072-.221-.107-.273-.107-.084 0-.147.049-.19.146-.042.098-.063.273-.063.527 0 .154.004.285.012.393.009.107.021.199.04.27.019.072.04.133.063.188.023.053.06.1.107.143.047.041.147.102.301.182s.348.156.583.23.506.137.813.186c.307.051.634.076.983.076.576 0 1.107-.07 1.594-.211s.903-.346 1.252-.615c.35-.27.621-.602.817-.998.195-.396.293-.852.293-1.365 0-.307-.053-.594-.159-.859-.105-.268-.257-.508-.455-.719s-.44-.387-.726-.527-.608-.23-.968-.273v-.023c.302-.074.567-.186.797-.334.23-.146.422-.328.575-.539s.27-.451.349-.721.119-.561.119-.873c0-.402-.067-.764-.202-1.082-.135-.32-.333-.59-.595-.811-.262-.219-.584-.387-.968-.502-.383-.117-.823-.176-1.319-.176-.381 0-.733.033-1.059.1s-.611.146-.86.242c-.248.096-.454.193-.618.293-.164.102-.272.176-.325.227s-.091.096-.115.139c-.023.043-.044.092-.06.15s-.026.131-.031.219c-.006.086-.008.197-.008.328 0 .16.005.289.016.389.011.102.026.178.048.23.021.053.047.088.079.107.031.018.068.027.111.027.063 0 .162-.043.297-.127s.299-.176.491-.273c.193-.098.411-.188.654-.27s.502-.123.777-.123c.243 0 .454.033.634.1s.326.156.44.27c.113.113.199.248.258.404.058.156.087.32.087.496 0 .227-.042.434-.127.621-.084.189-.207.348-.369.48-.16.133-.36.234-.598.305-.238.072-.511.107-.817.107h-.896c-.063 0-.117.012-.162.033-.045.02-.082.057-.111.109s-.051.129-.063.227c-.014.098-.02.223-.02.377 0 .164.006.297.02.4.013.104.036.184.067.242s.071.096.119.115c.047.018.105.027.174.027h.889c.375 0 .701.037.979.111s.508.178.69.313c.182.135.319.299.412.488.093.191.139.404.139.643 0 .217-.038.414-.115.592C21.496 29.592 21.38 29.742 21.224 29.867zM28.91 31.926c.587 0 1.104-.092 1.554-.273.449-.184.827-.434 1.134-.754s.539-.701.698-1.143c.158-.441.237-.922.237-1.439 0-.459-.056-.877-.166-1.254-.111-.375-.284-.695-.52-.959s-.538-.467-.908-.611c-.37-.143-.813-.213-1.332-.213-.232 0-.451.018-.657.051-.207.035-.398.078-.575.131s-.341.117-.491.191c-.151.074-.284.146-.4.221.005-.4.05-.781.135-1.141.084-.361.219-.676.404-.949.185-.271.425-.486.721-.646.297-.158.658-.236 1.087-.236.253 0 .477.016.67.047.192.031.36.068.503.111.143.041.265.08.365.115.101.033.182.051.246.051.053 0 .098-.014.135-.039.036-.027.065-.07.087-.131.021-.061.035-.146.043-.254.009-.109.013-.244.013-.408 0-.105-.003-.197-.008-.27-.006-.074-.015-.137-.028-.188-.013-.051-.03-.096-.052-.139-.021-.043-.051-.08-.091-.115-.04-.033-.12-.074-.242-.123-.121-.047-.27-.09-.443-.127-.175-.037-.364-.066-.567-.09-.203-.025-.405-.037-.606-.037-.634 0-1.183.086-1.646.254-.462.17-.855.398-1.181.686-.325.289-.591.625-.797 1.008s-.366.787-.479 1.211c-.114.422-.19.854-.23 1.291-.039.439-.06.859-.06 1.262 0 .48.019.936.056 1.365.037.428.104.824.202 1.189.098.363.229.691.393.982s.375.539.635.742c.259.203.565.359.919.467C28.02 31.871 28.435 31.926 28.91 31.926zM27.522 27.396c.111-.074.23-.145.357-.211.126-.064.259-.123.396-.17.137-.047.277-.084.42-.111.143-.025.288-.039.436-.039.249 0 .46.035.635.107.174.07.314.178.42.316.105.141.183.313.23.516.047.203.071.441.071.711 0 .258-.032.498-.096.717-.063.221-.156.412-.277.574-.122.164-.273.291-.456.381s-.395.135-.638.135c-.249 0-.467-.045-.654-.139-.188-.092-.344-.25-.468-.471-.124-.223-.218-.523-.281-.9C27.555 28.434 27.522 27.963 27.522 27.396zM35.301 31.564c.46.24 1.041.361 1.744.361.692 0 1.277-.125 1.756-.373s.867-.605 1.165-1.07c.299-.467.515-1.029.646-1.689.132-.662.198-1.402.198-2.221 0-.826-.053-1.564-.158-2.217-.106-.654-.294-1.207-.563-1.658-.27-.453-.636-.799-1.098-1.039-.463-.24-1.045-.361-1.748-.361-.688 0-1.271.125-1.748.373-.479.248-.867.605-1.166 1.07-.299.467-.516 1.031-.65 1.693-.135.664-.202 1.402-.202 2.217 0 .826.055 1.564.163 2.217.108.654.297 1.207.566 1.658C34.476 30.979 34.841 31.324 35.301 31.564zM35.649 24.979c.048-.451.131-.826.25-1.127.118-.301.279-.527.483-.678.203-.152.461-.227.772-.227.18 0 .344.023.492.07.147.049.28.129.396.242s.215.266.297.457c.082.189.15.422.206.697s.097.6.123.973c.026.371.04.801.04 1.289 0 .4-.01.768-.028 1.102-.019.332-.053.633-.103.896-.051.264-.115.496-.194.697s-.179.367-.298.5-.258.23-.416.297-.341.1-.547.1c-.275 0-.51-.057-.706-.17-.195-.113-.355-.313-.479-.596s-.215-.664-.273-1.143c-.058-.479-.087-1.082-.087-1.811C35.578 25.951 35.602 25.428 35.649 24.979zM43.554 26.377c.269.141.606.211 1.017.211.404 0 .745-.072 1.024-.217.278-.146.506-.354.679-.625.175-.27.3-.6.378-.984.076-.387.115-.816.115-1.295 0-.48-.031-.91-.093-1.291-.063-.381-.171-.703-.328-.967s-.371-.467-.641-.607c-.27-.139-.609-.209-1.019-.209-.4 0-.74.072-1.019.217-.279.145-.507.354-.681.625-.174.27-.3.6-.378.986-.079.387-.119.818-.119 1.293 0 .48.031.912.095 1.291.063.381.174.705.331.967C43.073 26.035 43.286 26.238 43.554 26.377zM43.757 22.537c.028-.262.077-.48.146-.656.069-.176.164-.307.282-.396.118-.086.27-.131.45-.131.105 0 .201.014.287.041.087.029.163.076.23.143.069.066.126.154.174.266.049.111.088.246.12.406.033.16.057.35.072.566.015.219.022.469.022.752 0 .234-.005.447-.016.643-.011.193-.032.369-.061.521-.029.154-.066.291-.112.408-.047.117-.104.213-.175.291-.068.078-.149.135-.241.174-.093.039-.2.057-.32.057-.16 0-.297-.033-.411-.1-.113-.066-.207-.18-.278-.346-.073-.166-.127-.387-.16-.666-.034-.279-.052-.631-.052-1.057C43.715 23.104 43.729 22.799 43.757 22.537z" />
                      <path fill="#000000" d="M34.62 10.645c-.54-.02-1.02.4-1.05.951-.03.549.39 1.02.94 1.049C46.84 13.355 56.5 19.416 56.5 26.436c0 5.66-6.109 10.73-15.34 12.85v-2.971c0-.369-.2-.709-.53-.889-.33-.17-.72-.15-1.029.059l-11.73 8.021c-.27.189-.439.5-.439.83s.17.639.439.818l11.73 8.031c.17.109.369.17.56.17.16 0 .33-.041.47-.121.33-.17.53-.51.53-.879v-3.711C54.66 46.215 64 38.625 64 30.006 64 19.775 51.37 11.455 34.62 10.645zM24.351 39.605c-9.931-1.859-16.86-7.27-16.86-13.17 0-7.02 9.67-13.08 22-13.791.55-.029.97-.5.94-1.049-.03-.551-.49-.98-1.04-.951C12.63 11.455 0 19.775 0 30.006c0 8.898 9.88 16.648 24.011 18.84.05.01.1.01.149.01.24 0 .47-.08.66-.24.22-.189.34-.471.34-.76v-7.26C25.16 40.105 24.82 39.695 24.351 39.605z" />
                    </svg>
                    <p>Digital Consulting</p>
                  </div>
                  <div className="hizmetler-card">
                    <a href="/whatsapp-marketing/" target="_blank" rel="noreferrer"></a>
                    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 50 50">
                      <path d="M36.27,28.11c-.09-.04-3.32-1.64-3.9-1.84-.23-.08-.49-.17-.75-.17-.44,0-.8.22-1.09.65-.32.48-1.3,1.62-1.6,1.97-.04.05-.09.1-.13.1-.03,0-.53-.21-.68-.27-3.47-1.51-6.11-5.14-6.47-5.75-.05-.09-.05-.13-.05-.13.01-.05.13-.16.19-.22.18-.17.37-.4.55-.63.09-.11.18-.21.26-.31.27-.31.39-.55.53-.83l.07-.15c.34-.67.05-1.24-.04-1.42-.08-.15-1.44-3.45-1.59-3.8-.35-.84-.81-1.23-1.45-1.23-.06,0,0,0-.25.01-.3.01-1.96.23-2.69.69-.78.49-2.09,2.05-2.09,4.79,0,2.47,1.57,4.8,2.24,5.69.02.02.05.07.09.13,2.58,3.76,5.79,6.55,9.04,7.85,3.13,1.25,4.62,1.4,5.46,1.4h0c.35,0,.64-.03.89-.05l.16-.02c1.08-.1,3.46-1.33,4-2.83.43-1.18.54-2.48.26-2.95-.19-.32-.53-.48-.95-.68Z" />
                      <path d="M26.01,2.6C13.98,2.6,4.2,12.31,4.2,24.24c0,3.86,1.03,7.64,2.99,10.95l-3.75,11.05c-.07.21-.02.43.13.59.11.11.26.17.41.17.06,0,.12,0,.17-.03l11.52-3.66c3.15,1.68,6.72,2.57,10.32,2.57,12.02,0,21.81-9.71,21.81-21.64S38.03,2.6,26.01,2.6ZM26.01,41.38c-3.39,0-6.68-.98-9.51-2.83-.09-.06-.21-.09-.32-.09-.06,0-.12,0-.17.03l-5.77,1.83,1.86-5.5c.06-.18.03-.37-.08-.53-2.15-2.94-3.29-6.41-3.29-10.04,0-9.45,7.75-17.14,17.27-17.14s17.27,7.69,17.27,17.14c0,9.45-7.75,17.13-17.27,17.13Z" />
                    </svg>
                    <p>WhatsApp Marketing</p>
                  </div>
                  <div className="hizmetler-card">
                    <a href="/ui-ux-design/" target="_blank" rel="noreferrer"></a>
                    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 95 95">
                      <rect width="95" height="95" fill="none" />
                      <path d="M16.826,3H72.219L88.046,22.783H1Z" transform="translate(2.957 8.87)" fillRule="evenodd" opacity="0.3" />
                      <path d="M88.046,8,44.523,55.479,1,8Z" transform="translate(2.957 23.653)" fillRule="evenodd" />
                    </svg>
                    <p>UI/UX Design</p>
                  </div>
                  <div className="hizmetler-card">
                    <a href="/web-development/" target="_blank" rel="noreferrer"></a>
                    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 101 101">
                      <g transform="translate(-0.115 -0.115)">
                        <rect width="101" height="101" transform="translate(0.115 0.115)" fill="none" />
                        <path d="M69.579,14.1a4.215,4.215,0,0,1,6.138-5.777L92.576,26.238a4.215,4.215,0,0,1,0,5.777L75.717,49.927a4.215,4.215,0,1,1-6.138-5.777l14.14-15.024Zm-44.437,0L11,29.127,25.142,44.15A4.215,4.215,0,1,1,19,49.927L2.146,32.015a4.215,4.215,0,0,1,0-5.777L19,8.326A4.215,4.215,0,1,1,25.142,14.1Z" transform="translate(3.179 22.466)" />
                        <rect width="8.429" height="67.434" rx="1" transform="matrix(0.966, 0.259, -0.259, 0.966, 55.195, 16.881)" opacity="0.3" />
                      </g>
                    </svg>
                    <p>Website Development</p>
                  </div>
                  <div className="hizmetler-card">
                    <a href="/generative-ai/" target="_blank" rel="noreferrer"></a>
                    <img className="svgnew" alt="Generative AI Consulting" src={svgnew} />
                    <p>Generative AI Consulting</p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </Layout>
    )
  }
}

export default Convert
